import React, { useState, useEffect } from "react";
import {
  Modal,
  TextField,
  Button,
  Typography,
  IconButton,
  MenuItem,
} from "@mui/material";
import { ModalBox } from "../../../styles/ModalStyles";
import CloseIcon from "@mui/icons-material/Close";
import { getClienteHabilitado } from "../../http/actions/ClientesAction";

const AgregarClienteUsuarioModal = ({ open, onClose, onSubmit, usuario }) => {
    const [clientes, setClientes] = useState([]);
    const [selectedCliente, setSelectedCliente] = useState('');
  
    useEffect(() => {
      fetchClientes();
    }, []);
  
    const fetchClientes = () => {
      getClienteHabilitado(localStorage.getItem("token"))
        .then((response) => {
          setClientes(response);
        })
        .catch((error) => {
          console.log(error);
        });
    };
  
    const handleSubmit = (event) => {
      event.preventDefault();
      onSubmit({
        idUsuario: usuario.id,
        idCliente: selectedCliente
      });
    };
  
    return (
      <Modal open={open} onClose={onClose}>
        <ModalBox>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6">Agregar cliente a usuario</Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              select
              fullWidth
              label="Cliente"
              value={selectedCliente}
              onChange={(e) => setSelectedCliente(e.target.value)}
              margin="normal"
            >
              {clientes.map((cliente) => (
                <MenuItem key={cliente.id} value={cliente.id}>
                  {cliente.nombre}
                </MenuItem>
              ))}
            </TextField>
            <Button type="submit" variant="contained" color="primary">
              Agregar
            </Button>
          </form>
        </ModalBox>
      </Modal>
    );
  };

export default AgregarClienteUsuarioModal;